import React, { useCallback } from "react";
import { useStore } from 'react-redux';
import { Form } from "react-bootstrap";

import { BERATER_KENNZEICHEN } from "../../utils/enums";
import { console } from "../../utils/functions";
import { InputError } from ".";

export const SelectBeratung = (props) => {
  const { value, display, onChange, error, ...attributes } = props || {};
  const handleChange = useCallback((e) => {
    console.log(e);
    if (typeof onChange === "function") {
      onChange(e);
    }
  }, [onChange]);
  const { configStorage } = useStore().getState();

  if (!display) return;

  let { disabled, defaultValue } = props || {};
  switch (configStorage.getBeraterKennzeichen()) {
    case BERATER_KENNZEICHEN.DEFAULT_NONE_SELECT_YES_NO:
      break;
    case BERATER_KENNZEICHEN.DEFAULT_NO_SELECT_YES_NO:
      defaultValue = "N";
      break;
    case BERATER_KENNZEICHEN.DEFAULT_YES_SELECT_YES_NO:
      defaultValue = "J";
      break;
    default:
      return;
  }
  let option = value || "none";
  if (option === "none" && defaultValue) {
    option = defaultValue;
  }
  return (
    <div className="row mt-one-half mb-one-half align-items-center">
      <label htmlFor="beraterFeld" className="col-sm-6 col-lg-3 float-start fs-4 text-gray">
        Beratung
      </label>
      <div className="col-sm-6 col-lg-5">
        <Form.Select
          size="lg"
          name="beraterFeld"
          onChange={handleChange}
          value={option}
          disabled={disabled}
          isInvalid={error}
          {...attributes}
        >
          {// immer leeres default wenn ja oder nein nicht ausgewählt worden sind
            !defaultValue
              ? <option value="none">Bitte auswählen</option>
              : null
          }
          <option value="N">Nein</option>
          <option value="J">Ja</option>
        </Form.Select>
        {error
          ? <InputError>Bitte das Feld ausfüllen</InputError>
          : null
        }
      </div>
      <div className="col-12 col-lg-4">
        <p> </p>
      </div>
    </div>
  );
};
